import React from 'react';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import AppHeader from '../app-header';
import routes from '../../routes';

const LandingPage = () => {
  return (
    <div className="layout__root">
      <div className="layout__head">
        <AppHeader />
      </div>
      <div className="layout__body">
        <div className="layout__sidebar col-3">
          <div className="layout__sidebar-container">
            <img
              src={`${process.env.PUBLIC_URL}/TIRC_MAIN_SPLASH_LEFT.png`}
              alt="TIRC splash"
            />
            <div className="gradient-overlay"></div>
          </div>
        </div>
        <div className="layout__content col-9 grey-bg">
          <div className="front-emptystate">
            <div className="front-emptystate-headline-container">
              <div>
                <h1>TIRC</h1>
                <h3>Technical Information Requirement Catalog</h3>
              </div>
            </div>
            <div className="section-container">
              <div className="standards-header">
                <h4>Standards &amp; Governance</h4>
                <Link
                  className="portal-navigation-link company-page-link"
                  to={routes.company}
                >
                  <span>Company</span>
                  <FontAwesomeIcon icon={faArrowRight} />
                </Link>
              </div>
              <div className="standards-links">
                <a className="standards-link-item" href="/z-018/">
                  <span className="standards-link-item-header">Z-018</span>
                  <span className="standards-link-item-label">
                    Supplier's documentation of equipment
                  </span>
                </a>
                <a className="standards-link-item" href="/z-001/">
                  <span className="standards-link-item-header">Z-001</span>
                  <span className="standards-link-item-label">
                    Facility life cycle information requirements
                  </span>
                </a>
                {/* STI link - uncomment when ready to publish
                <a className="standards-link-item" href="/sti/">
                  <span className="standards-link-item-header">STI</span>
                  <span className="standards-link-item-label">
                    Standardized technical information
                  </span>
                </a>
                */}
              </div>
            </div>
            <div className="section-container">
              <h4>Benefits</h4>
              <div className="benefits-ingress">
                <span>
                  Gives access to common technical information requirements to
                  help suppliers standardize and industrialize their equipment
                  documentation.
                </span>
              </div>
              <ul>
                <li>
                  Provides common, accepted requirements set for the whole value
                  chain
                </li>
                <li>
                  Available through the whole value chain – Operators,
                  contractors and suppliers
                </li>
                <li>
                  Provides common, standardized requirements for documentation
                </li>
                <li>
                  Provides predictability to all involved parties, giving
                  possibility to suppliers to standardize, industrialize, reuse
                  and reduce risk
                </li>
                <li>
                  Available through the whole value chain – Operators,
                  contractors and suppliers
                </li>
              </ul>
            </div>
            <div className="section-container grow">
              <h4>Support &amp; News</h4>
              <div className="support-news-container">
                <div>
                  <h4>
                    A digital framework for technical information requirements
                    including
                  </h4>
                  <ul>
                    <li>
                      Requirement conditions, definitions, justification and
                      reference data links
                    </li>
                    <li>
                      Export function to establish SDRL (supplier document
                      requirements list)
                    </li>
                  </ul>
                </div>
                <div>
                  <h4>Contact information</h4>
                  <ul>
                    <li>
                      <p>
                        Technical issues contact{' '}
                        <a href="mailto:tirc@collabor8.no">
                          tirc@collabor8.no
                        </a>
                      </p>
                    </li>
                    <li>
                      <p>
                        Content comments contact{' '}
                        <a href="mailto:z-ti@standard.no">z-ti@standard.no</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="support-news-footer">
                <p>Context Information</p>
                <ul>
                  <li>
                    <a href={`${process.env.PUBLIC_URL}/how_to_read_tirc.pdf`}>
                      How to read TIRC
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <img
          className="standard-image"
          alt="Standard Norge"
          title="Standard Norge"
          src={`${process.env.PUBLIC_URL}/Norsok_ORG.png`}
        />
      </div>
    </div>
  );
};

export default LandingPage;
